import React, { useState, useContext, useEffect, useRef } from "react";

import { ReactComponent as SORT } from "../../assets/icons/sort.svg";
import { ReactComponent as DELETE } from "../../assets/icons/delete.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as EDIT } from "../../assets/icons/editTeam.svg";
import { ReactComponent as TRASH } from "../../assets/icons/Trash.svg";
import { NotificationContext } from "../../Context/NotificationContext";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import TeamTitleWithSearch from "../../Components/ui/TeamTitleWithSearch";
import NoData from "../../NewComponents/NoData";
import { useParams } from "react-router-dom";
import { selectStatusBackground } from "../../Data/statuses";
import EditTeamPopUp from "../../NewComponents/EditTeamPopUp";
import "./SingleTeam.css";
import { firestore, getFullHttpUrl } from "../../firebase.config";
import PopUpModal from "../../NewComponents/PopUpModal";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import AddTeamMemberPopUp from "../../NewComponents/AddTeamMemberPopUp";
import { ReactComponent as GRANTADMIN } from "../../assets/icons/admin-v2.svg";
import { ReactComponent as REVOKEADMIN } from "../../assets/icons/revoke-admin.svg";
import axios from "axios";
import { DataContext } from "../../Context/DataContext";
import { AuthContext } from "../../Context/AuthContext";
import { FormTextInput } from "../../Components/FormTextInput";
import TeamDropdown from "../Account/OrdersComponents/TeamDropdown";
import SelectClient from "../Quote/QuoteComponents/SelectClient";
import SelectMemberTab from "../../NewComponents/SelectMemberTab";


const SingleTeam = ({ windowSize }) => {
  const { id } = useParams();
  const { signedIn } = useContext(AuthContext);
  const { showNotification } = useContext(NotificationContext);
  const { userData } = useContext(DataContext);
  const [team, setTeam] = useState(null);
  const [members, setMembers] = useState([]);
  const { transitionTo } = useScreenTransition();
  
  const [filterSearch, setFilterSearch] = useState("");
  const [moreOptions, setMoreOptions] = useState("");
  const [showDetailModal, setShowDetailModal] = useState("");
  const [selectedSort, setSelectedSort] = useState("teamJoinTimestamp");

  let firstLoad = useRef();
  if (!firstLoad.current) firstLoad.current = true;

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;
  const [deleteMemberPopUp, setDeleteMemberPopUp] = useState(false);
  const [makeAnadminPopUp, setMakeanAdminPopUp] = useState(false);
  const [makeAnOwnerPopUp, setMakeanOwnernPopUp] = useState(false);
  const [revokeAdminAccessPopUp, setRevokeAdminAccessPopUp] = useState(false);
  const [revokeOwnerAccessPopUp, setRevokeOwnerAccessPopUp] = useState(false);
  const [addMemberPopUpOpen, setAddMemberPopUpOpen] = useState(false);
  const [currentMember, setCurrentMember] = useState();
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [deleteTeamPopUp, setDeleteTeamPopUp] = useState(false);
  const [editTeamPopUp, setEditTeamPopUp] = useState(false);
  const [deleteTeamBtn, setDeleteTeamBtn] = useState("Delete Team");
  const [makeAdminBtn, setMakeAdminBtn] = useState("Make an Admin");
  const [makeOwnerBtn, setMakeOwnerBtn] = useState("Make an Owner");
  const [revokeAdminBtn, setRevokeAdminBtn] = useState("Revoke Admin Access");
  const [revokeOwnerBtn, setRevokeOwnerBtn] = useState("Revoke Owner Access");
  const [removeMemberBtn, setRemoveMemberBtn] = useState("Remove Member");
  const [loading, setLoading] = useState(true);
  const [weeklyInvoicePopUp, setWeeklyInvoicePopUp] = useState(false);
  const [addWeeklyInvoiceBtn, setAddWeeklyInvoiceBtn] = useState("Add");
  const [selectedWeeklyInvoiceMember, setSelectedWeeklyInvoiceMember] = useState({name: "", email: ""});
  const [teamAlreadyInWeeklyInvoice, setTeamAlreadyInWeeklyInvoice] = useState(false);
  const [removeFromWeeklyInvoicePopUp, setRemoveFromWeeklyInvoicePopUp] = useState(false);
  const [removeFromWeeklyInvoiceBtn, setRemoveFromWeeklyInvoiceBtn] = useState("Remove");
  const [viewOnBoardingDetails, setViewOnBoardingDetails] = useState(false);

  const checkIfTeamAlreadyInWeeklyInvoice = async (teamId) => {
    const weeklyInvoiceTeams = await firestore.collection("weeklyInvoiceTeams").doc(teamId).get();
    if(weeklyInvoiceTeams.exists){
      setTeamAlreadyInWeeklyInvoice(weeklyInvoiceTeams.data());
    }else{
      setTeamAlreadyInWeeklyInvoice(null);
    }
  }

   useEffect(() => {
        if(!signedIn || (userData && userData.role === "client")){
          return transitionTo("/");
        }
      }, [signedIn, userData]);

  const getUserOrders = async (email) => {
    if(!email){
      return
    }
    
    const ordersTotal = await firestore
      .collection("orders")
      .where("email", "==", email)
      .get()
      .then((oSnap) => {
        return oSnap.empty ? 0 : oSnap.docs.length;
      });

      return ordersTotal;
  };

  useEffect(() => {
    if(!id){
      transitionTo("/office/teams");
    }
    setLoading(true);
    const unsubscribe = firestore.collection("teams").doc(id).onSnapshot(async (teamDoc) => {
    try{ 
      if (teamDoc.exists) {
        const teamData = { id: teamDoc.id, ...teamDoc.data()};
        checkIfTeamAlreadyInWeeklyInvoice(teamDoc.id)

        setTeam(teamData);
      } else {
        transitionTo("/office/teams");
      } 
      setTimeout(() => {
        setLoading(false);
      }, 1000)

    }catch (error) {
      setLoading(false);
      console.error("Error fetching members: ", error);
      showNotification("Error", "Failed to fetch member data", "error");
    }
  });
      
    return () => unsubscribe();
  }, [id, userData]);

  useEffect(() => {
    if(!id){
      transitionTo("/office/teams");
    }
    setLoading(true);
    const unsubscribe = firestore.collection("users").where("teamId", "==", id).onSnapshot(async (snapshot) => {
      if(snapshot.empty){
        return;
      }
        try {
          const members = await Promise.all(
            snapshot.docs.map(async (userDoc) => {
              const ordersTotal = await Promise.resolve(getUserOrders(userDoc.data().email));
              return { id: userDoc.id, ordersTotal: ordersTotal, ...userDoc.data() };
            })
          );
    
          setMembers(members);
          // setUsersWithoutTeam(users.filter(u => u.teamId ? false : true))
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.error("Error fetching teams: ", error);
          showNotification("Error", "Failed to fetch team user data", "error");
        }
      });
    
      return () => unsubscribe();
  }, [id, userData])

  const sortData = (data) => {
    const sortedData = data.sort((a,b) => {
      if(selectedSort === "ordersTotal"){
        return b[selectedSort] - a[selectedSort];
      }
      if(selectedSort === "teamJoinTimestamp"){
        return a[selectedSort] - b[selectedSort];
      }

      return a[selectedSort].toLowerCase() > b[selectedSort].toLowerCase() ? 1 : -1;
    });

    return sortedData;
  }

  useEffect(() => {
    let filterdData = members
    if (filterSearch) {
      filterdData = filterdData.filter((item) => {
        return item.name.toLowerCase().includes(filterSearch.toLowerCase());
      });
    }

    setFilteredMembers(filterdData);
  }, [members, filterSearch, team])


  const handleOpenAddMemberPopUp = () => {
    setAddMemberPopUpOpen(true);
  };

  const handleCloseAddMemberPopUp = () => {
    setAddMemberPopUpOpen(false);
  };

  const btnMakeanAdmin = (member) => {
    setCurrentMember(member);
    setMakeanAdminPopUp(true);
  };

  const btnMakeanOwner = (member) => {
    setCurrentMember(member);
    setMakeanOwnernPopUp(true);
  };

  const btnRevokeOwnerAccess = (member) => {
    setCurrentMember(member);
    setRevokeOwnerAccessPopUp(true);
  };

  const btnRevokeAdminAccess = (member) => {
    setCurrentMember(member);
    setRevokeAdminAccessPopUp(true);
  };

  const btnDeleteMember = (member) => {
    setCurrentMember(member);
    setDeleteMemberPopUp(true);
  };
  const btnDeleteTeam = () => {
    setDeleteTeamPopUp(true);
  };
  const btnEditTeam = () => {
    setEditTeamPopUp(true);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return null;

    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    return splitted[1] + " " + splitted[2] + ", " + splitted[3];
  };

  const checkAnyFilterSelected = () => {
    if (filterSearch !== "") {
      return true;
    }

    return false;
  };

  const handleDeleteTeam = async (e) => {
    setDeleteTeamBtn("Deleting...");
    try{
      await firestore.collection("teams").doc(team.id).delete().then(() => {
        transitionTo("/office/teams", e)
        setDeleteTeamPopUp(false);
      });
    }catch (error) {
      console.error("Error deleting team: ", error);
      showNotification("Error", "Failed to delete team", "error");
    }finally{
      setDeleteTeamBtn("Delete Team");
    }
  }

  const handleMakeAdminClose = () => {
    setCurrentMember(null);
    setMakeanAdminPopUp(false);
  }
  const handleMakeOwnerClose = () => {
    setCurrentMember(null);
    setMakeanOwnernPopUp(false);
  }

  const handleRemoveOwnerClose = () => {
    setCurrentMember(null);
    setRevokeOwnerAccessPopUp(false);
  }
  const handleRemoveAdminClose = () => {
    setCurrentMember(null);
    setRevokeAdminAccessPopUp(false);
  }
  const handleRemoveMemberClose = () => {
    setCurrentMember(null);
    setDeleteMemberPopUp(false);
  }

  const handleMakeOwner = async() => {
    setMakeOwnerBtn("Making...");
    await firestore.collection("users").doc(currentMember.id).update({
      teamRole: "owner"
    })
      .then(async (res) => {
        setMakeOwnerBtn("Make an Owner");
        handleMakeOwnerClose();

        showNotification(
          "Success",
          "User has given admin access for this team.",
          "success"
        );
      })
      .catch((e) => {
        setMakeOwnerBtn("Make an Owner");
        // console.log(e);
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  const handleMakeAdmin = async() => {
    setMakeAdminBtn("Making...");
    await firestore.collection("users").doc(currentMember.id).update({
      teamRole: "admin"
    })
      .then(async (res) => {
        setMakeAdminBtn("Make an Admin");
        handleMakeAdminClose();

        showNotification(
          "Success",
          "User has given admin access for this team.",
          "success"
        );
      })
      .catch((e) => {
        setMakeAdminBtn("Make an Admin");
        // console.log(e);
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  const handleRevokeOwnerAccess = async() => {
      setRevokeOwnerBtn("Revoking...");
      await firestore.collection("users").doc(currentMember.id).update({
        teamRole: "member"
      })
        .then(async (res) => {
          setRevokeOwnerBtn("Revoke Owner Access");
          handleRemoveOwnerClose();
          showNotification(
            "Success",
            "Team admin access revoked from the user.",
            "success"
          );
        })
        .catch((e) => {
          setRevokeOwnerBtn("Revoke Owner Access");
          console.log(e);
          showNotification(
            "Error",
            "There was an error. Please, try again or refresh the page.",
            "error"
          );
        });
    };

  const handleRevokeAdminAccess = async() => {
      setRevokeAdminBtn("Revoking...");
      await firestore.collection("users").doc(currentMember.id).update({
        teamRole: "member"
      })
        .then(async (res) => {
          setRevokeAdminBtn("Revoke Admin Access");
          handleRemoveAdminClose();
          showNotification(
            "Success",
            "Team admin access revoked from the user.",
            "success"
          );
        })
        .catch((e) => {
          setRevokeAdminBtn("Revoke Admin Access");
          // console.log(e);
          showNotification(
            "Error",
            "There was an error. Please, try again or refresh the page.",
            "error"
          );
        });
    };

  const handleRemoveMember = () => {
    setRemoveMemberBtn("Removing...");
    axios({
      method: "post",
      url: getFullHttpUrl("team-removeMember"),
      data: {
        id: currentMember.id,
        email: currentMember.email
      },
    })
      .then(async (res) => {
        setRemoveMemberBtn("Remove Member");
        handleRemoveMemberClose();
        showNotification("Success", "Member removed from the team.", "success");
      })
      .catch((e) => {
        setRemoveMemberBtn("Remove Member");
        // console.log(e);
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  const handleAddToWeeklyInvoice = async () => {
    if(selectedWeeklyInvoiceMember.email === "" || selectedWeeklyInvoiceMember.name === ""){
      showNotification("Error", "Please select a member or enter a name and email", "error");
      return;
    }

    setAddWeeklyInvoiceBtn("Adding...");
    try{
      await firestore.collection("weeklyInvoiceTeams").doc(team.id).set({
        teamId: team.id,
        teamName: team.name,
        email: selectedWeeklyInvoiceMember.email,
        name: selectedWeeklyInvoiceMember.name,
        createdAt: new Date().getTime()
      }).then(() => {
        setAddWeeklyInvoiceBtn("Add");
        checkIfTeamAlreadyInWeeklyInvoice(team.id)
        setWeeklyInvoicePopUp(false);
        showNotification("Success", "Team added to weekly invoice", "success");
      })
    }catch (error) {
      console.error("Error adding to weekly invoice: ", error);
      showNotification("Error", "Failed to add to weekly invoice", "error");
    }finally{
      setAddWeeklyInvoiceBtn("Add");
    }
  }

  const handleRemoveFromWeeklyInvoice = async () => {
    setRemoveFromWeeklyInvoiceBtn("Removing...");
    try{
    await firestore.collection("weeklyInvoiceTeams").doc(team.id).delete().then(() => {
      setRemoveFromWeeklyInvoicePopUp(false);
      checkIfTeamAlreadyInWeeklyInvoice(team.id)
      showNotification("Success", "Team removed from weekly invoice", "success");
    })
    }catch (error) {
      console.error("Error removing from weekly invoice: ", error);
      showNotification("Error", "Failed to remove from weekly invoice", "error");
    }finally{
      setRemoveFromWeeklyInvoiceBtn("Remove");
    }
  }

  return (
    <>

    {editTeamPopUp && team && (
      <EditTeamPopUp
        currentTeam={team}
        onClose={() => setEditTeamPopUp(false)}
      />
    )}

    {addMemberPopUpOpen && team && (
      <AddTeamMemberPopUp
        existingTeams={[team]}
        currentTeam={team}
        onClose={handleCloseAddMemberPopUp}
        singleTeam={true}
      />
    )}

    {deleteTeamPopUp && team && (
      <PopUpModal
      title={"Delete Team"}
      backBtnText="Cancel"
      subText="Are you sure you want to delete the team? All users will lose access to the team and its privileges."
      text={team.name}
      btnText={deleteTeamBtn}
      iconBgColor="#FFF6EA"
      deleteBtn={true}
      showClose
      onClose={() => setDeleteTeamPopUp(false)}
      onClick={handleDeleteTeam}
      onBackClick={() => setDeleteTeamPopUp(false)}
      disableBtn={deleteTeamBtn === "Deleting..."}
      >
      <DELETE />
      </PopUpModal>
    )}


    {makeAnOwnerPopUp && currentMember && (
        <PopUpModal
          title={"Make an Owner"}
          backBtnText="Cancel"
          subText="Are you sure you want to make this member an owner?"
          text={currentMember.name}
          btnText={makeOwnerBtn}
          iconBgColor="##E6FAF2"
          showClose
          onClose={handleMakeOwnerClose}
          onClick={handleMakeOwner}
          onBackClick={handleMakeOwnerClose}
          disableBtn={makeOwnerBtn === "Making..."}
        >
          <GRANTADMIN />
        </PopUpModal>
      )}

    {makeAnadminPopUp && currentMember && (
        <PopUpModal
          title={"Make an Admin"}
          backBtnText="Cancel"
          subText="Are you sure you want to make this member an admin?"
          text={currentMember.name}
          btnText={makeAdminBtn}
          iconBgColor="##E6FAF2"
          showClose
          onClose={handleMakeAdminClose}
          onClick={handleMakeAdmin}
          onBackClick={handleMakeAdminClose}
          disableBtn={makeAdminBtn === "Making..."}
        >
          <GRANTADMIN />
        </PopUpModal>
      )}

      {revokeOwnerAccessPopUp && currentMember && (
          <PopUpModal
            title={"Revoke Owner Access"}
            backBtnText="Cancel"
            subText="Are you sure you want to revoke owner access for this user?"
            text={currentMember.name}
            btnText={revokeOwnerBtn}
            iconBgColor="#FFF6EA"
            deleteBtn={true}
            showClose
            onClose={handleRemoveOwnerClose}
            onClick={handleRevokeOwnerAccess}
            onBackClick={handleRemoveOwnerClose}
            disableBtn={revokeOwnerBtn === "Revoking..."}
          >
            <REVOKEADMIN />
          </PopUpModal>
        )}

      {revokeAdminAccessPopUp && currentMember && (
          <PopUpModal
            title={"Revoke Admin Access"}
            backBtnText="Cancel"
            subText="Are you sure you want to revoke admin access for this user?"
            text={currentMember.name}
            btnText={revokeAdminBtn}
            iconBgColor="#FFF6EA"
            deleteBtn={true}
            showClose
            onClose={handleRemoveAdminClose}
            onClick={handleRevokeAdminAccess}
            onBackClick={handleRemoveAdminClose}
            disableBtn={revokeAdminBtn === "Revoking..."}
          >
            <REVOKEADMIN />
          </PopUpModal>
        )}

      {deleteMemberPopUp && currentMember && (
          <PopUpModal
            title={"Remove Member"}
            backBtnText="Cancel"
            subText="Are you sure you want to remove this member?"
            text={currentMember.name}
            btnText={removeMemberBtn}
            iconBgColor="#FFF6EA"
            deleteBtn={true}
            showClose
            onClose={handleRemoveMemberClose}
            onClick={handleRemoveMember}
            onBackClick={handleRemoveMemberClose}
            disableBtn={removeMemberBtn === "Removing..."}
          >
            <REVOKEADMIN />
          </PopUpModal>
        )}

      {weeklyInvoicePopUp && (
          <PopUpModal
            title={"Add to Weekly Invoice"}
            backBtnText="Cancel"
            subText="Are you sure you want to add this team to the weekly invoice?"
            text={team.name}
            btnText={addWeeklyInvoiceBtn}
            iconBgColor="#FFF6EA"
            showClose
            onClose={() => setWeeklyInvoicePopUp(false)}
            onClick={() => {handleAddToWeeklyInvoice()}}
            onBackClick={() => setWeeklyInvoicePopUp(false)}
            disableBtn={addWeeklyInvoiceBtn === "Adding..."}
            components={
              <SelectMemberTab members={members} setSelectedMember={setSelectedWeeklyInvoiceMember} selectedMember={selectedWeeklyInvoiceMember} />
            }
            hideIcon={true}
          >
          </PopUpModal>
        )}

      {removeFromWeeklyInvoicePopUp && (
          <PopUpModal
            title={"Remove from Weekly Invoice"}
            backBtnText="Cancel"
            subText="Are you sure you want to remove this team from the weekly invoice?"
            text={team.name}
            btnText={removeFromWeeklyInvoiceBtn}
            iconBgColor="#FFF6EA"
            showClose
            deleteBtn={true}
            onClose={() => setRemoveFromWeeklyInvoicePopUp(false)}
            onClick={() => {handleRemoveFromWeeklyInvoice()}}
            onBackClick={() => setRemoveFromWeeklyInvoicePopUp(false)}
            disableBtn={removeFromWeeklyInvoiceBtn === "Removing..."}
            hideIcon={true}
            components={
              <div className=" w-full flex flex-col gap-2">
                <FormTextInput
                  placeholder="Member Name"
                  value={teamAlreadyInWeeklyInvoice?.name}
                  disabled={true}
                />
                <FormTextInput
                  placeholder="Member Email"
                  value={teamAlreadyInWeeklyInvoice?.email}
                  disabled={true}
                />
              </div>
            }
          >
          </PopUpModal>
        )}
      {viewOnBoardingDetails && team.onBoarding && (
          <PopUpModal
            title={"Team OnBoarding Details"}
            subText=""
            text={""}
            showClose
            hideIcon
            onClose={() => setViewOnBoardingDetails(false)}
            components={
            <div className="w-full flex flex-col gap-4">

              {team.onBoarding.translation_workflow && <div>
                <h2 className="MainTitle font-[500] text-[#38465C]">1. How does your firm currently handle certified translations?</h2>
                <p className="accountDetailsHeading ml-4 mt-1">{team.onBoarding.translation_workflow}</p>
              </div>}

              {(team.onBoarding.immigration_platforms || team.onBoarding.immigration_other_platform) && <div>
                <h2 className="MainTitle font-[500] text-[#38465C]">2. Which platforms does your team use for case or client management?</h2>
                <div className="flex gap-1 justify-start align-center ml-4 mt-1">
                {team.onBoarding.immigration_platforms && team.onBoarding.immigration_platforms.length > 0 && team.onBoarding.immigration_platforms.map(item => <p key={item} className="accountDetailsHeading">{item}, </p>)}
                {team.onBoarding.immigration_other_platform && <p className="accountDetailsHeading">{team.onBoarding.immigration_other_platform} </p>}
                </div>
              </div>}

              {team.onBoarding.team_size && <div>
                <h2 className="MainTitle font-[500] text-[#38465C]">3. Roughly how many team members would actively use eVerbary?</h2>
                <p className="accountDetailsHeading ml-4 mt-1">{team.onBoarding.team_size}</p>
              </div>}
            </div>
            }
          >
          </PopUpModal>
        )}

      <AccountNavBar
        windowSize={windowSize}
        selectedTab={"teams"}
        accountMainPadding={false}
        admin={true}
        showButton={true}
        breadLinkType="teams"
        bgTransparent={true}
        breadLink={`${""}`}
      >
        {
          <div className="mainOrderTitleWrapper">
            <div className="mainOrderTitleWrapper">
              <h2 className="createOrderNavbarMenuTitle">{`${
                team ? team.name : ""
              }`}</h2>
              <div className="mainOrderStatusWrap"></div>
            </div>
            <div className="mainOrderSecondaryContent mainOrderTransBtnWrap max-md:flex-wrap">
              <div className="flex flex-row items-center gap-2 bg-white  rounded-md font-medium text-[#030F23] px-3 py-1 cursor-pointer">
                <p className="teamName">
                  Discount : {`${team ? team.discount : ""}`} |
                  Expedited :{" "}
                  {`${team ? team.expeditedServices : ""}`}
                </p>
              </div>
              <div
                className="flex flex-row items-center gap-2 bg-white border border-[#E6E7E9] rounded-md font-normal text-[#030F23] px-3 py-1 cursor-pointer"
                onClick={() => btnEditTeam()}
              >
                <EDIT /> Edit Team
              </div>
              <div
                className="flex flex-row items-center gap-2 bg-white border border-[#E6E7E9] rounded-md font-normal text-[#030F23] px-3 py-1 cursor-pointer"
                onClick={() => btnDeleteTeam()}
              >
                <TRASH /> Delete Team
              </div>
              {!teamAlreadyInWeeklyInvoice ? <div
                className="flex flex-row items-center gap-2 bg-white border border-[#E6E7E9] rounded-md font-normal text-[#030F23] px-3 py-1 cursor-pointer"
                onClick={() => setWeeklyInvoicePopUp(true)}
              >
                Add to Weekly Invoice
              </div> : 
              <div
              className="flex flex-row items-center gap-2 bg-white border border-[#E6E7E9] rounded-md font-normal text-[#030F23] px-3 py-1 cursor-pointer"
              onClick={() => setRemoveFromWeeklyInvoicePopUp(true)}
            >
              Remove from Weekly Invoice
            </div>
              }
            {team && team.onBoarding && <div
              className="flex flex-row items-center gap-2 bg-white border border-[#E6E7E9] rounded-md font-normal text-[#030F23] px-3 py-1 cursor-pointer"
              onClick={() => setViewOnBoardingDetails(true)}
            >
              OnBoarding Details
            </div>}
            </div>
            
          </div>
        }
        <div className="singleteamPrimaryOptionsWrapper">
{/*         
immigration_other_platform ""
(string)
2 immigration_platforms
(array)
0 "Docketwise"
(string)
3 team_size "👤 1-5"
(string)
1. translation_workflow "We outsource to a translation provider"  */}
         
          <TeamTitleWithSearch
            title="Team Members"
            placeholder="Search by Member Name"
            onAddMemberClick={handleOpenAddMemberPopUp}
            showCreateBtn={false}
            onSearch={(val) => setFilterSearch(val)}
          />

          {loading ? 
            <NoData type="teams" loading={true} showBtn={false} loadingText={"team"}/>:
             filteredMembers?.length === 0 && !checkAnyFilterSelected() ? (
            <NoData
              type="teams"
              title={"This Team has no Members"}
              loading={loading}
              showBtn={false}
              loadingText={"team"}
            />
          ) : (
            <div className="accountDetailsScroll">
              <table className="accountDetailsTable">
                <thead>
                  <tr>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">No.</p>
                      </div>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">Name</p>
                        {selectedSort === "name" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => setSelectedSort("name")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => setSelectedSort("name")}
                          />
                        )}
                      </div>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">Email</p>
                        {selectedSort === "email" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => setSelectedSort("email")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => setSelectedSort("email")}
                          />
                        )}
                      </div>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">Join date</p>
                        {selectedSort === "teamJoinTimestamp" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => setSelectedSort("teamJoinTimestamp")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => setSelectedSort("teamJoinTimestamp")}
                          />
                        )}
                      </div>
                    </th>
                    <th>
                      <div className="accountData">
                        <p className="accountDetailsHeading">Role</p>
                        {selectedSort === "teamRole" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => setSelectedSort("teamRole")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => setSelectedSort("teamRole")}
                          />
                        )}
                      </div>
                    </th>
                    <th>
                      <div
                        className="accountData"
                        style={{ maxWidth: "170px" }}
                      >
                        <p className="accountDetailsHeading">Orders</p>
                        {selectedSort === "ordersTotal" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => setSelectedSort("ordersTotal")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => setSelectedSort("ordersTotal")}
                          />
                        )}
                      </div>
                    </th>
                    <th>
                      <div
                        className="accountData"
                        style={{ maxWidth: "170px" }}
                      >
                        <p className="accountDetailsHeading">Status</p>
                        {selectedSort === "teamStatus" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => setSelectedSort("teamStatus")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => setSelectedSort("teamStatus")}
                          />
                        )}
                      </div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                {filteredMembers.length > 0 && (
                  <tbody>
                    {sortData(filteredMembers).map((member, i) => (
                      <tr key={member.userId + i}>
                        <td>
                          <p className="accountDetailsText">{i + 1}</p>
                        </td>
                        <td>
                          {member.name &&
                            member.name.length > 15 &&
                            showDetailModal === member.userId + member.name && (
                              <div className="accountdetailHoverBox">
                                <p className="accountDetailsText capitalize"
                                >
                                  {member.name}
                                </p>
                              </div>
                            )}
                          <p
                            className="accountDetailsText captialLetters"
                            style={{ cursor: "pointer" }}
                            onMouseOver={() =>
                              setShowDetailModal(member.userId + member.name)
                            }
                            onMouseLeave={() => setShowDetailModal("")}
                          >
                            {member.name}
                          </p>
                        </td>

                        <td>
                          <p className="accountDetailsText">{member?.email}</p>
                        </td>

                        <td>
                          <p className="accountDetailsText">
                            {formatDate(member.teamJoinTimestamp)}
                          </p>
                        </td>

                        <td>
                          <p className="accountDetailsText capitalize">{member?.teamRole}</p>
                        </td>
                        <td>
                          <p className="accountDetailsText">
                            {member.ordersTotal || "-"}
                          </p>
                        </td>
                        <td>
                          <p
                            className="accountDetailsText accountDetailsStatus"
                            style={{
                              backgroundColor: selectStatusBackground(
                                member.teamStatus
                              ),
                            }}
                          >
                            {member.teamStatus}
                          </p>
                        </td>
                        {
                          <td>
                            <div
                              className="hardCopyAddressIconWrap"
                            >
                              {moreOptions === member.id ? (
                                <MORESELECTED
                                  className="hardCopyAddressIcon"
                                  onClick={(e) => {e.stopPropagation(); setMoreOptions("")}}
                                />
                              ) : (
                                <MORE
                                  className="hardCopyAddressIcon"
                                  onClick={(e) => {e.stopPropagation(); setMoreOptions(member.id)}}
                                />
                              )}

                              {moreOptions === member.id && (
                                <div className="hardCopyAddressEditWrap">
                                  {(member.teamRole === "admin" || member.teamRole === "member") && (
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() => btnMakeanOwner(member)}
                                    >
                                      Make an Owner
                                    </div>
                                  )}
                                  {member.teamRole === "member" && (
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() => btnMakeanAdmin(member)}
                                    >
                                      Make an Admin
                                    </div>
                                  )}
                                  {member.teamRole === "owner" && (
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() =>
                                        btnRevokeOwnerAccess(member)
                                      }
                                    >
                                      Revoke Owner Access
                                    </div>
                                  )}
                                  {member.teamRole === "admin" && (
                                    <div
                                      className="hardCopyAddressEdit"
                                      onClick={() =>
                                        btnRevokeAdminAccess(member)
                                      }
                                    >
                                      Revoke Admin Access
                                    </div>
                                  )}

                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => btnDeleteMember(member)}
                                  >
                                    Remove member
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                        }
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>

            </div>
          )}
        </div>
      </AccountNavBar>
    </>
  );
};

export default SingleTeam;
